import type { Dispatch } from 'react';
import type { WorkspaceObjectRole } from '@/enums';
import type { Workspace, WorkspaceObject } from '@/types';
import type { GroupUser } from '@/types/group';
import { createNamedContext } from '@trinity/chat-components';
import type { ObjectAccess } from './interfaces';

export type ObjectAccessStateContextValue =
  [ObjectAccess.State, Dispatch<ObjectAccess.Actions>];

export type ObjectAccessContextValue = {
  object: WorkspaceObject;
  workspace: Workspace;
};

export type UserObjectAccessContextValue = {
  roles: WorkspaceObjectRole[];
  selectedRole: WorkspaceObjectRole;
} & IUserId;

export type GroupUsersContext = {
  items: GroupUser[];
  fetch: (value?: string) => unknown;
};

type FetchAccess = () => unknown;

export const FetchObjectAccessContext = createNamedContext<FetchAccess>(undefined, 'fetch-object-access');
export const ObjectAccessContext = createNamedContext<ObjectAccessContextValue>(undefined, 'object-access');
export const ObjectAccessStateContext = createNamedContext<ObjectAccessStateContextValue>(undefined, 'object-access-state');
export const ObjectAccessLoadingContext = createNamedContext<boolean>(false, 'object-access-loading');
export const SaveObjectAccessContext = createNamedContext<ObjectAccess.SaveObjectAccess.Fn>(undefined, 'save-object-access');
export const UserObjectAccessContext = createNamedContext<UserObjectAccessContextValue>(undefined, 'user-object-access');
export const GroupUsersContext = createNamedContext<GroupUsersContext>(undefined, 'group-users');